import { createReducer } from "@reduxjs/toolkit";
const initialState = {
  loading: false,
  data: [],
  error: false,
};

 const metricExpertReducer = (state = initialState, action) => {
  switch (action.type) {
    case "METRIC_REQ":
      return {
        ...state,
        loading: true,
        error: false,
      };

    case "METRIC_FETCH_SUC":
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
      };

    case "METRIC_ERROR":
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};
export default metricExpertReducer;